import React from 'react';
import { TrendingUp, Info } from 'lucide-react';
import AnalysisMarkdown from '../common/AnalysisMarkdown';
import { CPGQuestionAnalysis } from './types';

interface CPGInsightCardProps {
  analysis: CPGQuestionAnalysis;
}

const CPGInsightCard: React.FC<CPGInsightCardProps> = ({ analysis }) => {
  if (!analysis.synthesis) {
    return null;
  }

  return (
    <div className="space-y-4">
      {/* Strategic Synthesis */}
      {analysis.synthesis && (
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <div className="flex items-start space-x-3">
            <TrendingUp className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-blue-600 uppercase tracking-wide mb-2">Strategic Insight</p>
              <AnalysisMarkdown>{analysis.synthesis}</AnalysisMarkdown>
            </div>
          </div>
        </div>
      )}

      {/* Counter Arguments */}
      {analysis.counter_arguments && analysis.counter_arguments.length > 0 && (
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <div className="flex items-start space-x-3">
            <Info className="w-4 h-4 text-slate-500 mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-slate-600 uppercase tracking-wide mb-2">Worth Noting</p>
              {analysis.counter_arguments.map((arg, idx) => (
                <AnalysisMarkdown key={idx}>{arg}</AnalysisMarkdown>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CPGInsightCard;